import { api } from '@/lib/api'

import type { Report } from './types'

/**
 * Fetch all enabled alerts
 * @param tenant - The tenant ID
 * @param start_time - The start time
 * @param end_time - The end time
 */
export const fetchReport = async (
	tenant: string,
	start_time?: string,
	end_time?: string,
	signal?: AbortSignal,
) => {
	const baseURL = `/api/tenants/${tenant}/reports/soar`
	const params = new URLSearchParams()

	if (start_time) params.set('start_time', start_time)
	if (end_time) {
		params.set('end_time', end_time)
	} else {
		params.set('end_time', new Date().toISOString())
	}

	const requestURL = params.toString()
		? `${baseURL}?${params.toString()}`
		: baseURL

	const { data } = await api.get<Report>(requestURL, {
		signal,
	})

	return data
}

/**
 * Fetch all BitLyft AIR® Reports
 * @param tenant - The tenant ID
 */
export const fetchAirReport = async (tenant: string, signal?: AbortSignal) => {
	const { data } = await api.get<{ files: Array<string> }>(
		`/api/tenants/${tenant}/reports/air`,
		{
			signal,
		},
	)

	return data
}

/**
 * Fetch a single BitLyft AIR® Report
 * @param tenant - The tenant ID
 * @param report_name - The report name
 */
export const fetchAirReportDownloadLink = async (
	tenant: string,
	report_name: string,
	signal?: AbortSignal,
) => {
	const { data } = await api.get<{ download_link: string }>(
		`/api/tenants/${tenant}/reports/air/${report_name}`,
		{
			signal,
		},
	)

	return data
}
